import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Estatus from './estatus';
import EstatusDeleteDialog from './estatus-delete-dialog';
import EstatusDetail from './estatus-detail';
import EstatusUpdate from './estatus-update';

const EstatusRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Estatus />} />
    <Route path="new" element={<EstatusUpdate />} />
    <Route path=":id">
      <Route index element={<EstatusDetail />} />
      <Route path="edit" element={<EstatusUpdate />} />
      <Route path="delete" element={<EstatusDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EstatusRoutes;
